import GoogleMapsApiLoader from 'google-maps-api-loader';

class GoogleMapsLoader {
    get apiKey() {
        return this._apiKey;
    }

    set apiKey(value) {
        this._apiKey = value;
    }

    get googleMapsApi() {
        return this._googleMapsApi;
    }

    set googleMapsApi(value) {
        this._googleMapsApi = value;
    }

    get createHTMLMapMarker() {
        return this._customGoogleMapsMarker;
    }

    set createHTMLMapMarker(value) {
        this._customGoogleMapsMarker = value;
    }

    async loadGMapsApi() {
        try {
            this._googleMapsApi = await GoogleMapsApiLoader({
                apiKey: this.apiKey,
                libraries: ['places']
            });

            this._customGoogleMapsMarker = ({
                                                OverlayView = this.googleMapsApi.maps.OverlayView,
                                                vm = this,
                                                ...args
                                            }) => {
                class HTMLMapMarker extends OverlayView {
                    constructor() {
                        super();
                        this.latlng = args.latlng;
                        this.html = args.html;
                        this.setMap(args.map);
                    }

                    createDiv() {
                        this.div = document.createElement('div');
                        this.div.style.position = 'absolute';
                        if (this.html) {
                            this.div.innerHTML = this.html;
                        }
                        vm.googleMapsApi.maps.event.addDomListener(this.div, 'click', event => {
                            vm.googleMapsApi.maps.event.trigger(this, 'click');
                        });
                    }

                    appendDivToOverlay() {
                        const panes = this.getPanes();
                        panes.overlayImage.appendChild(this.div);
                    }

                    positionDiv() {
                        const point = this.getProjection().fromLatLngToDivPixel(
                            new vm.googleMapsApi.maps.LatLng(this.latlng.lat, this.latlng.lng)
                        );
                        let offset = 25;
                        if (point) {
                            this.div.style.left = `${point.x - offset}px`;
                            this.div.style.top = `${point.y - offset}px`;
                        }
                    }

                    draw() {
                        if (!this.div) {
                            this.createDiv();
                            this.appendDivToOverlay();
                        }
                        this.positionDiv();
                    }

                    remove() {
                        if (this.div) {
                            this.div.parentNode.removeChild(this.div);
                            this.div = null;
                        }
                    }

                    getPosition() {
                        return this.latlng;
                    }

                    getDraggable() {
                        return false;
                    }
                }

                return new HTMLMapMarker();
            };
        } catch (e) {
            throw e;
        }
    }
}

const googleMapsLoader = new GoogleMapsLoader();

export default googleMapsLoader;
